import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { isBDO } from '../../redux/profile/selectors'
import { search } from '../../redux/search/actions'
import { isLoading } from '../../redux/search/selectors'
import GlobalSearch from './GlobalSearch'

const selector = createStructuredSelector({
  isLoading,
  isBDO,
})
const actions = {
  search,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>

export interface IGlobalSearchOwnProps {
  isMobile?: boolean
  onClose?: () => void
}

export default createConnector<
  typeof connector,
  IGlobalSearchOwnProps & PropsFromRedux,
  PropsFromRedux
>(connector, GlobalSearch)
